export default __webpack_public_path__ + "static/media/3-sistemas-gestao.0c1cb2ab.webp";